import { useMutation, useQueryClient } from '@tanstack/vue-query';
import { abandonWorkout } from '../workout.api';
import { useAppToasts } from '@/hooks/use-app-toasts';
import { QueryKey } from '@/api/common/types/query-key.enum';

export const useAbandonWorkout = () => {
  const queryClient = useQueryClient();
  const { raiseErrorToast } = useAppToasts();
  const { mutateAsync, isPending } = useMutation({
    mutationKey: ['abandon-workout'],
    mutationFn: (workoutEventId: string) => abandonWorkout(workoutEventId),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: [QueryKey.GetWorkouts] });
      await queryClient.invalidateQueries({ queryKey: [QueryKey.GetRecoverableWorkout] });
    },
    onError: () => {
      raiseErrorToast();
    },
  });
  return {
    abandonWorkout: mutateAsync,
    loading: isPending,
  };
};
